function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#EB5757"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 10.4546,
  y: 4.82322,
  width: 1.02139,
  height: 7.96387,
  rx: 0.510693,
  transform: "rotate(45 10.4546 4.82322)",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.1768,
  y: 10.4545,
  width: 1.02139,
  height: 7.96387,
  rx: 0.510693,
  transform: "rotate(135 11.1768 10.4545)",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.25
});

var SvgHighlightOff = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHighlightOff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/highlight_off.c0c4fca5.svg";
export { ForwardRef as ReactComponent };